import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/**
 * Core actions for this feature.
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    open: store.actions.standalone({
      data: store.actions.Data.asIs<State.Context>(),
      reducer: ({ state, data }): State => State.open(state, data),
    }),
    clear: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }): State => State.clear(state),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
